/** Status → PrimeNG p-tag severity maps, shared by the dashboard + records pages. */

export type Severity = 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast';

export const PAY: Record<string, Severity> = {
  SUCCESS: 'success',
  PAID: 'success',
  PENDING: 'warn',
  INITIATED: 'info',
  FAILED: 'danger',
  CANCELLED: 'danger',
  REFUNDED: 'secondary',
  UNPAID: 'warn',
};

export const KYC: Record<string, Severity> = {
  VERIFIED: 'success',
  PENDING: 'warn',
  NOT_VERIFIED: 'danger',
};
